import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { TaskLoader } from '@doxyme/ui';
export const Loader = ({ onBack, status }) => {
    const { formatMessage } = useIntl();
    return (<React.Fragment>
      <div className="payment-setup__task-loader-container">
        <TaskLoader loadingLabel={formatMessage({ id: 'auth.payment-setup.loader-pending' })} statusLabel={status === 'success'
            ? formatMessage({ id: 'auth.payment-setup.loaderSuccess' })
            : ''} status={status}/>
        {status === 'failed' && (<div className="task-loader__failed-text-container" data-test-id="payment-failed-container">
            <div className="task-loader__failed-text-title">
              <FormattedMessage id="auth.payment-setup.failed-title"/>
            </div>
            <div className="task-loader__failed-text-subtext">
              <FormattedMessage id="auth.payment-setup.failed-subtext"/>
            </div>
            <a className="task-loader__failed-refresh-button" onClick={onBack}>
              <button className="btn btn-primary">
                <FormattedMessage id="auth.payment-setup.failed-refresh-button"/>
              </button>
            </a>
          </div>)}
      </div>
    </React.Fragment>);
};
